import React, { useRef, useState, useEffect } from "react";
import './EventsManagement.css';
import Autocomplete from 'react-google-autocomplete'
import Header from "../../Components/Header/Header";
import CustomDropdown from "../../Components/DropDown/CustomDropdown";
import Icons from "../../Constants/Icons";
import Colors from "../../Constants/Colors";
import { useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import CustomPagination from "../../Components/CustomPagination/CustomPagination";
import {
  setLoadingFalse,
  setLoadingTrue,
} from "../../Config/Actions/loadingActions";
import {
  apiCallGetAllEvent,
  apiCallGetEventStatus,
  onAPiCallSearchEvent,
  onAPiCallToggleEventFeatured,
  apiCallGetAllCities,
  apiCallGetAllStates,
  apiCallGetAllContreies
} from "../../Core/Apicall";
import EmptyData from "../../Components/EmptyData/EmptyData";
import UseDebounce from "../../Components/UseDebounce";
import { CustomCommonBox } from "../../Components/CustomCommonBox/CustomCommonBox";
import UpcomingEventsScreen from "../../Components/CustomDashboardScreen/UpcomingEventsScreen";

import MasterEventsTab from "./MasterEvents";
import TodayEventsTab from "./TodayEvents";
import UpcomingEventTab from "./UpcomingEvent";
import PastEventTab from "./PastEvent";
import AdminEventsTab from "./AdminEvent";
import SubMasterEvents from "./SubMasterEvents";

const CHIPS = [
  { label: "EVENTS", route: "/EventsManagement" },
  { label: "TODAY EVENTS", route: "/TodayEvents" },
  { label: "UPCOMING EVENTS", route: "/UpcomingEvent" },
  { label: "PAST EVENTS", route: "/PastEvent" },
];

function getChipFromPath(pathname) {
  return CHIPS.find((c) => c.route === pathname) || CHIPS[0];
}

function ChipBar({ selected, onChange }) {
  return (
    <div
      style={{
        display: "inline-flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "2px",
        padding: "5px",
        margin: "15px",
        background: "rgba(6, 101, 228, 0.15)",
        border: "1px solid rgba(6, 101, 228, 0.35)",
        boxShadow: "0 4px 24px rgba(6, 101, 228, 0.15)",
        borderRadius: "999px",
        backdropFilter: "blur(8px)",
      }}
    >
      {CHIPS.map((c) => {
        const active = selected === c.label;
        return (
          <button
            key={c.label}
            onClick={() => onChange(c)}
            style={{
              height: "38px",
              padding: "0 22px",
              borderRadius: "999px",
              border: "none",
              background: active ? "rgba(6, 101, 228, 0.75)" : "transparent",
              color: active ? "#FFFFFF" : "rgba(255,255,255,0.55)",
              boxShadow: active ? "0 2px 12px rgba(6, 101, 228, 0.4)" : "none",
              fontSize: "12px",
              fontWeight: active ? "700" : "500",
              letterSpacing: "0.8px",
              textTransform: "uppercase",
              cursor: "pointer",
              transition: "all 0.2s ease",
              whiteSpace: "nowrap",
              fontFamily: "Poppins, sans-serif",
            }}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}

export function LocationFilter({
  searchValue,
  startDate,
  endDate,
  onSearch
}) {
  const dispatch = useDispatch();

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);

  const [selectedCountry, setSelectedCountry] = useState("");
  const [selectedCountryCode, setSelectedCountryCode] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [selectedStateCode, setSelectedStateCode] = useState("");
  const [selectedCity, setSelectedCity] = useState("");

  const [countrySearch, setCountrySearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [citySearch, setCitySearch] = useState("");

  // Dropdown open states
  const [isCountryOpen, setIsCountryOpen] = useState(false);
  const [isStateOpen, setIsStateOpen] = useState(false);
  const [isCityOpen, setIsCityOpen] = useState(false);

  // Fetch countries on mount
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const { data } = await apiCallGetAllContreies();
        setCountries(data || []);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
      }
    };
    fetchCountries();
  }, [dispatch]);

  // Fetch states when country changes
  useEffect(() => {
    if (selectedCountryCode) {
      const fetchStates = async () => {
        try {

          const { data } = await apiCallGetAllStates({ countryCode: selectedCountryCode });
          setStates(data || []);
        } catch (error) {
          console.error("Error fetching states:", error);
        } finally {

        }
      };
      fetchStates();
    } else {
      setStates([]);
    }
    setSelectedState("");
    setSelectedStateCode("");
    setSelectedCity("");
    setCities([]);
    setStateSearch("");
    setCitySearch("");
  }, [selectedCountryCode, dispatch]);

  useEffect(() => {
    if (selectedCountryCode && selectedStateCode) {
      const fetchCities = async () => {
        try {

          const { data } = await apiCallGetAllCities({
            countryCode: selectedCountryCode,
            stateCode: selectedStateCode
          });
          setCities(data || []);
        } catch (error) {
          console.error("Error fetching cities:", error);
        } finally {
        }
      };
      fetchCities();
    } else {
      setCities([]);
    }
    // Reset city when state changes
    setSelectedCity("");
    setCitySearch(""); // Clear city search
  }, [selectedCountryCode, selectedStateCode, dispatch]);

  // Filter function
  const triggerSearch = (country, state, city) => {
    const params = {
      text: searchValue,
      page: 0,
      fromDate: startDate || "",
      toDate: endDate || "",
      country: country || "",
      state: state || "",
      city: city || ""
    };
    onSearch(params);
  };

  const handleCountrySelect = (country) => {
    const newCountry = selectedCountry === country.countryName ? "" : country.countryName;
    const newCode = selectedCountry === country.countryName ? "" : country.countryCode;
    setSelectedCountry(newCountry);
    setSelectedCountryCode(newCode);
    setSelectedState("");
    setSelectedStateCode("");
    setSelectedCity("");
    setCountrySearch("");
    setIsCountryOpen(false);
    triggerSearch(newCountry, "", "");
  };

  const handleStateSelect = (state) => {
    const newState = selectedState === state.stateName ? "" : state.stateName;
    const newCode = selectedState === state.stateName ? "" : state.stateCode;
    setSelectedState(newState);
    setSelectedStateCode(newCode);
    setSelectedCity("");
    setStateSearch("");
    setIsStateOpen(false);
    triggerSearch(selectedCountry, newState, "");
  };

  const handleCitySelect = (city) => {
    const newCity = selectedCity === city.cityName ? "" : city.cityName;
    setSelectedCity(newCity);
    setCitySearch("");
    setIsCityOpen(false);
    triggerSearch(selectedCountry, selectedState, newCity);
  };

  const clearLocationFilters = () => {
    setSelectedCountry("");
    setSelectedCountryCode("");
    setSelectedState("");
    setSelectedStateCode("");
    setSelectedCity("");
    setStates([]);
    setCities([]);
    setCountrySearch("");
    setStateSearch("");
    setCitySearch("");
    setIsCountryOpen(false);
    setIsStateOpen(false);
    setIsCityOpen(false);
    triggerSearch("", "", "");
  };

  const getFilteredItems = (items, searchTerm, displayKey) => {
    if (!items || items.length === 0) return [];
    if (!searchTerm || searchTerm.trim() === "") return items;
    const searchLower = searchTerm.toLowerCase().trim();
    return items.filter(item => {
      const value = item[displayKey];
      if (!value) return false;
      return value.toLowerCase().includes(searchLower);
    });
  };

  const LocationDropdown = ({
    isOpen,
    setIsOpen,
    items,
    selectedValue,
    searchTerm,
    setSearchTerm,
    onSelect,
    placeholder,
    displayKey,
    noDataMessage = "No options available",
    disabled = false
  }) => {
    const dropdownRef = useRef(null);
    const filteredItems = getFilteredItems(items, searchTerm, displayKey);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setIsOpen(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [setIsOpen]);

    useEffect(() => {
      if (items.length === 0 && isOpen) {
        setIsOpen(false);
      }
    }, [items, isOpen, setIsOpen]);

    return (
      <div className={`location-dropdown-container ${disabled ? 'disabled' : ''}`} ref={dropdownRef}>
        <div
          className={`location-dropdown-header ${isOpen ? 'active' : ''} ${selectedValue ? 'has-value' : ''}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
        >
          <span className={selectedValue ? 'selected' : 'placeholder'}>
            {selectedValue || placeholder}
          </span>
          <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>
            <svg width="10" height="10" viewBox="0 0 12 8" fill="none">
              <path d="M1 1.5L6 6.5L11 1.5" stroke="#e28d25" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </span>
        </div>

        {isOpen && !disabled && (
          <div className="location-dropdown-menu">
            <div className="location-dropdown-search">
              <img className="search-icon-small" src={Icons.ic_search} alt="search" />
              <input
                type="text"
                className="location-search-input"
                placeholder={`Search ${placeholder.toLowerCase()}...`}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                onClick={(e) => e.stopPropagation()}
                autoFocus
              />
              {searchTerm && (
                <span
                  className="clear-search"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSearchTerm("");
                  }}
                >
                  ✕
                </span>
              )}
            </div>
            <div className="location-dropdown-items">
              {filteredItems.length > 0 ? (
                filteredItems.map((item, index) => {
                  const displayValue = item[displayKey] || "";
                  const isSelected = selectedValue === displayValue;
                  return (
                    <div
                      key={index}
                      className={`location-dropdown-item ${isSelected ? 'selected' : ''}`}
                      onClick={() => onSelect(item)}
                    >
                      <span>{displayValue}</span>
                      {isSelected && (
                        <span className="check-mark">✓</span>
                      )}
                    </div>
                  );
                })
              ) : (
                <div className="location-dropdown-no-data">
                  {searchTerm ? `No results found for "${searchTerm}"` : noDataMessage}
                </div>
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="location-filter-wrapper" style={{}}>
      <div className="location-filter-container">

        <div className="location-dropdowns-group">
          <LocationDropdown
            isOpen={isCountryOpen}
            setIsOpen={setIsCountryOpen}
            items={countries}
            selectedValue={selectedCountry}
            searchTerm={countrySearch}
            setSearchTerm={setCountrySearch}
            onSelect={handleCountrySelect}
            placeholder="Country"
            displayKey="countryName"
            noDataMessage={countries.length === 0 ? "Loading..." : "No countries found"}
          />

          <div className="location-dropdown-divider" />

          <LocationDropdown
            isOpen={isStateOpen}
            setIsOpen={setIsStateOpen}
            items={states}
            selectedValue={selectedState}
            searchTerm={stateSearch}
            setSearchTerm={setStateSearch}
            onSelect={handleStateSelect}
            placeholder="State"
            displayKey="stateName"
            noDataMessage={selectedCountryCode ? "No states" : "Select country first"}
            disabled={!selectedCountryCode}
          />

          <div className="location-dropdown-divider" />

          <LocationDropdown
            isOpen={isCityOpen}
            setIsOpen={setIsCityOpen}
            items={cities}
            selectedValue={selectedCity}
            searchTerm={citySearch}
            setSearchTerm={setCitySearch}
            onSelect={handleCitySelect}
            placeholder="City"
            displayKey="cityName"
            noDataMessage={selectedStateCode ? "No cities" : "Select state first"}
            disabled={!selectedStateCode}
          />
        </div>

        {(selectedCountry || selectedState || selectedCity) && (
          <button
            className="location-clear-btn"
            onClick={clearLocationFilters}
            title="Clear location filters"
          >
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
}

function EventsTab() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const page = Number(new URLSearchParams(location.search).get("page")) || 1;

  useEffect(() => {
    setInitialPage(page - 1);
    if (searchValue) {
      searchFilterFunction({
        text: searchValue,
        page: page - 1,
        fromDate: startDate,
        toDate: endDate,
        country: locationFilters?.country || "",
        state: locationFilters?.state || "",
        city: locationFilters?.city || "",
        status: DropdownLabelSelect
      });
    } else {
      onApiEventTypeList(page - 1, DropdownLabelSelect);
    }
  }, [page]);

  const statusDropdownItem = ["All", "Activate", "Deactivate"];
  const [event, setEvent] = useState();
  const [searchValue, setSearchValue] = useState("");
  const [searchByVenue, setSearchByVenue] = useState("");
  const [DropdownLabelSelect, setDropdownLabelSelect] = useState("All");
  const [initialPage, setInitialPage] = useState(page - 1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInActive, setTotalInActive] = useState(0);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isDatePickerOpen, setIsDatePickerOpen] = useState(false);
  const [locationFilters, setLocationFilters] = useState({
    country: "",
    state: "",
    city: ""
  });

  const debouncedInput = UseDebounce(searchValue, 500);
  const isInitialRender = useRef(true);

  useEffect(() => {
    if (isInitialRender.current) { isInitialRender.current = false; return; }
    searchFilterFunction({
      text: searchValue,
      page: 0,
      fromDate: startDate,
      toDate: endDate,
      country: locationFilters?.country || "",
      state: locationFilters?.state || "",
      city: locationFilters?.city || "",
      status: DropdownLabelSelect
    });
  }, [debouncedInput]);

  useEffect(() => { onApiEventTypeList(0, "All"); }, []);

  const handleSelect = (status) => {
    setDropdownLabelSelect(status);
    if (startDate == "" && endDate == "" && locationFilters?.country == "" && locationFilters?.state == "" && locationFilters?.city == "" && searchValue == "") {
      onApiEventTypeList(0, status);
    } else {
      searchFilterFunction({
        text: searchValue,
        page: 0,
        fromDate: startDate,
        toDate: endDate,
        country: locationFilters?.country || "",
        state: locationFilters?.state || "",
        city: locationFilters?.city || "",
        status: status
      });
    }
  };
  const searchFilterFunction = async ({
    text = "",
    page = 0,
    fromDate = "",
    toDate = "",
    country = "",
    state = "",
    city = "",
    status = DropdownLabelSelect
  } = {}) => {
    dispatch(setLoadingTrue());
    try {
      const params = {
        status: status,
        searchQuery: text,
        offset: page + 1,
        limit: 15
      };

      if (fromDate) params.fromDate = fromDate;
      if (toDate) params.toDate = toDate;
      if (country) params.country = country;
      if (state) params.state = state;
      if (city) params.city = city;
      const res = await onAPiCallSearchEvent(params);
      setLocationFilters({
        country: country,
        state: state,
        city: city,
      })
      setInitialPage(page);
      setEvent(res);
    } catch (error) {
      console.error("Search error:", error);
    } finally {
      dispatch(setLoadingFalse());
    }
  };

  const onApiEventTypeList = async (selectedPage, DropdownLabelSelect) => {
    dispatch(setLoadingTrue());
    try {
      const response = await apiCallGetAllEvent({ status: DropdownLabelSelect, offset: selectedPage + 1, limit: 15 });
      setTotalCount(response?.allEvent);
      setTotalActive(response?.allActiveEvent);
      setTotalInActive(response?.allDeActiveEvent);
      setInitialPage(selectedPage ?? 0);
      setEvent(response);
    } catch (error) { console.error(error); }
    finally { dispatch(setLoadingFalse()); }
  };

  const handelEnabled = async (data) => {
    dispatch(setLoadingTrue());
    try {
      await apiCallGetEventStatus({ eventId: data.eventId, isEnabled: !data.isEnabled });
      if (data.isEnabled) { setTotalActive(p => p - 1); setTotalInActive(p => p + 1); }
      else { setTotalActive(p => p + 1); setTotalInActive(p => p - 1); }
      const updater = (prev) => ({
        ...prev,
        data: prev.data.map((item) =>
          item.eventId === data.eventId ? { ...item, isEnabled: !item.isEnabled } : item
        ),
      });
      setEvent(updater);
    } catch { }
    finally { dispatch(setLoadingFalse()); }
  };

  const onClickFeaturedStatus = async (data) => {
    dispatch(setLoadingTrue());
    try {
      await onAPiCallToggleEventFeatured({ eventId: data.eventId, isFeatured: !data.isFeatured });
      const updater = (prev) => ({
        ...prev,
        data: prev.data.map((item) =>
          item.eventId === data.eventId ? { ...item, isFeatured: !item.isFeatured } : item
        ),
      });
      setEvent(updater);
    } catch { }
    finally { dispatch(setLoadingFalse()); }
  };

  const formatDateDisplay = (dateString) => {
    if (!dateString) return "DD --- YYYY";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "DD --- YYYY";
    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const isDateSelected = (dateString) => {
    return dateString && dateString.length > 0;
  };

  const handleDateChange = (type, value) => {
    if (type === 'from') {
      setStartDate(value);
      if (value && endDate) {
        searchFilterFunction({
          text: searchValue,
          page: 0,
          fromDate: value,
          toDate: endDate,
          country: locationFilters?.country || "",
          state: locationFilters?.state || "",
          city: locationFilters?.city || "",
          status: DropdownLabelSelect
        });
      }
    } else {
      setEndDate(value);
      if (value && startDate) {
        searchFilterFunction({
          text: searchValue,
          page: 0,
          fromDate: startDate,
          toDate: value,
          country: locationFilters?.country || "",
          state: locationFilters?.state || "",
          city: locationFilters?.city || "",
          status: DropdownLabelSelect
        });
      }
    }
  };

  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    setIsDatePickerOpen(false);
    searchFilterFunction({
      text: searchValue,
      page: 0,
      fromDate: "",
      toDate: "",
      country: locationFilters?.country || "",
      state: locationFilters?.state || "",
      city: locationFilters?.city || "",
      status: DropdownLabelSelect
    });
  };

  return (
    <>
      <div className="Event-AlignSelf">
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="astrologer-inner">
            <div className="frame-container">
              <div className="frame-div">
                {[
                  { label: "Total Events", color: "", count: totalCount },
                  { label: "Total Activate", color: Colors.darkGreen, count: totalActive },
                  { label: "Total Deactivate", color: Colors.darkBlue, count: totalInActive },
                ].map((items, index) => (
                  <CustomCommonBox
                    key={index}
                    label={items.label}
                    color={items.color}
                    count={items.count}
                    onClickTabOpen={() => { }}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="astrologers-list-parent padding-top-bottom">
        <div className="frame-parent2">
          <div className="custom-box-user">
            <div className="custom-container-dropdown-div" style={{ height: "40px", }}>
              <CustomDropdown
                dropDownLabel={DropdownLabelSelect}
                items={statusDropdownItem}
                color="blue"
                onSelect={handleSelect}
                customLabelStyle={{ fontWeight: "400", color: "white" }}
              />
            </div>

            <div className="custom-box-search-div">
              <img className="custom-image" alt="" src={Icons.ic_search} />
              <input
                type="text"
                className="searchTextInput"
                placeholder="Search"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
            </div>

            <LocationFilter
              searchValue={searchValue}
              startDate={startDate}
              endDate={endDate}
              onSearch={searchFilterFunction}
            />

            <div className="date-range-wrapper">
              <div
                className={`custom-box-search-div ${isDatePickerOpen ? 'active' : ''}`}
                onClick={() => setIsDatePickerOpen(!isDatePickerOpen)}
                style={{ minWidth: "300px" }}
              >
                <div className="date-range-icon">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 10H21M7 3V5M17 3V5M6 2H18C19.1046 2 20 2.89543 20 4V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V4C4 2.89543 4.89543 2 6 2Z"
                      stroke="#e28d25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    <path d="M8 14H10M10 14H12M12 14H14M14 14H16M8 18H10M10 18H12M12 18H14M14 18H16"
                      stroke="#e28d25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
                <span className="date-range-text">
                  <span className="date-label">From</span>
                  <span className={`date-value ${!isDateSelected(startDate) ? 'empty' : ''}`}>
                    {formatDateDisplay(startDate)}
                  </span>
                  <span className="date-separator">→</span>
                  <span className="date-label">To</span>
                  <span className={`date-value ${!isDateSelected(endDate) ? 'empty' : ''}`}>
                    {formatDateDisplay(endDate)}
                  </span>
                </span>
                <div className={`date-range-arrow ${isDatePickerOpen ? 'open' : ''}`}>
                  <svg width="10" height="10" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M1 1.5L6 6.5L11 1.5" stroke="#e28d25" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </div>
              </div>

              {isDatePickerOpen && (
                <div className="date-picker-dropdown">
                  <div className="date-picker-container">
                    <div className="date-picker-group">
                      <label className="date-picker-label">From Date</label>
                      <input
                        type="date"
                        className="date-picker-input"
                        value={startDate}
                        onChange={(e) => handleDateChange('from', e.target.value)}
                      />
                    </div>
                    <div className="date-picker-divider"></div>
                    <div className="date-picker-group">
                      <label className="date-picker-label">To Date</label>
                      <input
                        type="date"
                        className="date-picker-input"
                        value={endDate}
                        onChange={(e) => handleDateChange('to', e.target.value)}
                      />
                    </div>
                    <div className="date-picker-divider"></div>

                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </div >

      {/* Table */}
      < div className="Event-custom-style" >
        <div className="lastWeekEndDiv Event-AlignSelf-stretch">
          <div className="user_title event-flex-container">Events list</div>
          <div className="Achievements-class-name">
            <div className="achievement-content">
              <div className="achievement-content-header">
                <div className="lastWeekEndDivGreyColor w-8">image</div>
                <div className="lastWeekEndDivGreyColor w-10">Name</div>
                <div className="lastWeekEndDivGreyColor w-22">Events Name</div>
                <div className="lastWeekEndDivGreyColor w-30">Date & times</div>
                <div className="lastWeekEndDivGreyColor w-10">Actions</div>
                <div className="lastWeekEndDivGreyColor w-10">Status</div>
                  <div className="lastWeekEndDivGreyColor w-10">Cancel</div>

                <div className="lastWeekEndDivGreyColor w-10">Featured</div>
              </div>
              <div className="scrollable-container transform_data">
                <UpcomingEventsScreen
                  handelEnabled={handelEnabled}
                  data={event?.data}
                  cancel={true}
                  onClickFeaturedStatus={onClickFeaturedStatus}
                />
              </div>
            </div>
          </div>
        </div>

        {
          event?.data?.length === 0 && (
            <div className="empty-centered" style={{ paddingBottom: "10px" }}>
              <EmptyData />
            </div>
          )
        }
      </div >

      {event?.data?.length !== 0 && (
        <div className="Custom-Pagination">
          <CustomPagination
            pageCount={event?.totalCount / 15}
            pageRangeDisplayed={3}
            initialPage={initialPage}
            marginPagesDisplayed={1}
            onPageChange={({ selected }) => {
              setInitialPage(selected);
              navigate(`/EventsManagement?page=${selected + 1}`);
              if (startDate == "" && endDate == "" && locationFilters?.country == "" && locationFilters?.state == "" && locationFilters?.city == "" && searchValue == "") {
                onApiEventTypeList(selected, DropdownLabelSelect);
              } else {
                searchFilterFunction({
                  text: searchValue,
                  page: selected,
                  fromDate: startDate,
                  toDate: endDate,
                  country: locationFilters?.country || "",
                  state: locationFilters?.state || "",
                  city: locationFilters?.city || "",
                  status: DropdownLabelSelect
                });
              }
            }}
          />
        </div>
      )
      }
    </>
  );
}


const CHIP_COMPONENTS = {
  "EVENTS": EventsTab,
  "TODAY EVENTS": TodayEventsTab,
  "UPCOMING EVENTS": UpcomingEventTab,
  "PAST EVENTS": PastEventTab,
};

function EventsManagement() {
  const navigate = useNavigate();
  const location = useLocation();

  const [selectedChip, setSelectedChip] = useState(
    () => getChipFromPath(location.pathname)
  );

  useEffect(() => {
    const matched = getChipFromPath(location.pathname);
    if (matched.label !== selectedChip.label) setSelectedChip(matched);
  }, [location.pathname]);

  const handleChipChange = (chip) => {
    setSelectedChip(chip);
    navigate(chip.route);
  };

  const ActiveScreen = CHIP_COMPONENTS[selectedChip.label] || EventsTab;

  return (
    <div>
      <Header name={"Events Management"} />
      <ChipBar selected={selectedChip.label} onChange={handleChipChange} />
      <ActiveScreen />
    </div>
  );
}

export default EventsManagement;